import axios from "axios";
import React from "react";
import { Table, Dropdown } from "react-bootstrap";
import swal from "sweetalert";
import "./Orders.css";
const Orders = ({ orders }) => {
  const token = JSON.parse(localStorage.getItem("user"));
  function getSelectedStatus(e, order) {
    const value = e.target.value;
    changeOrderStatus(order?.paymentId, value);
  }

  const changeOrderStatus = (paymentId, status) => {
    axios
      .patch(
        "https://mysterious-sierra-48850.herokuapp.com/update-order-status",
        { paymentId, status },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + token.token,
          },
        }
      )
      .then((data) => {
        if (data.data.success) {
          swal("", `${data?.data?.message}`, "success");
        }
      })
      .catch((err) => {
        console.log(err.response);
        swal("", `something went wrong`, "error");
      });
    // console.log(order,value);
  };

  return (
    <>
      <h3 className="text-center">
        Orders : <span className="text-info"> {orders?.length}</span>
      </h3>
      <div>
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>UserName</th>
              <th>Services</th>
              <th>Total Price</th>
              <th>Pay With</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, i) => {
              return (
                <tr key={order._id}>
                  <td>{i + 1}</td>
                  <td>{order?.userName}</td>
                  <td>
                    {order?.products.map((pd, i) => {
                      return <p key={i}>{pd?.name}</p>;
                    })}
                  </td>
                  <td>${order?.totalPrice}</td>
                  <td> Card</td>
                  <td>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      onChange={(e) => getSelectedStatus(e, order)}
                    >
                      {order.status === "pending" ? (
                        <>
                          <option value="pending" selected>
                            {order?.status}
                          </option>
                          <option value="approved">approve</option>
                          <option value="rejected">reject</option>
                        </>
                      ) : order.status === "approved" ? (
                        <>
                          <option value="approved" selected>
                            {order?.status}
                          </option>
                          <option value="rejected">reject</option>
                          <option value="pending">pending</option>
                        </>
                      ) : (
                        <>
                          <option value="rejected" selected>
                            {order?.status}
                          </option>
                          <option value="approved">approve</option>
                          <option value="pending">pending</option>
                        </>
                      )}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default Orders;
